import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import MainPage from './pages/main';
import Layout from './layouts';

function App() {
  return (
    <BrowserRouter>
      <Layout variant="main">
        <MainPage />
      </Layout>
    </BrowserRouter>
  );
}

export default App;
